import img from "/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg";
import gImg from "/images/GetItOnGooglePlay_Badge_Web_color_English.png";

export default function AppStoreBranding() {
  return (
    <div
      id="appstore-branding"
      className="my-6 flex flex-col items-center justify-center gap-2 sm:flex-row"
    >
      <div style={{ width: "185px" }}>
        <a href="https://apps.apple.com/us/app/rollcall2/id6743412390">
          <img
            src={img}
            alt="Download on the App Store"
            style={{ width: "100%" }}
          />
        </a>
      </div>
      <div style={{ width: "50px" }} />
      <div style={{ width: "195px" }}>
        <a href="https://play.google.com/store/apps/details?id=com.brandonlehr.rollcall2">
          <img width="200" alt="Get it on Google Play" src={gImg} />
        </a>
      </div>
    </div>
  );
}
